<template>
    <div class="millenniumDetails">
        <swiperList :swiperStyle="{padding: '0 0 .8rem'}">
            <div class="topImg">
                <img :src="bgImg">
            </div>
            <div class="textBox"></div>
            <h2>{{ currentData.title }}</h2>
            <p><span>{{ currentData.description }}</span></p>
            <textContent></textContent>
        </swiperList>
        <backButton :routerName="routerName" zIindex="10"></backButton>
        <!-- <backButton :routerName="routerName" zIndex="100"></backButton> -->
    </div>
</template>

<script>
import textContent from "@/components/textContent";
// import backButton from "@/components/backButton";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            currentData: {},
        }
    },
    created(){
        this.currentData = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
    },
    computed: {
        routerName(){
            if(this.secondLevelIndex == 0){
                return "jingtan";
            }else if(this.secondLevelIndex == 2){
                return "feiyi";
            }
            return "food";
        },
        bgImg(){
            if(this.currentData.images){
                let arr = this.currentData.images.replace(/\n/g,"").split("<br />");
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].indexOf("背景") != -1 || arr[i].indexOf("GPS") != -1){
                        return this.getImgSrc(arr[i],false);
                    }
                }
            }
        },
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","levelThreeIndex"])
    },
    components: {
        textContent,
        // backButton
    }
}
</script>

<style lang="scss" scoped>
.millenniumDetails{
    .topImg{
        width: 100%;
        height: 4.22rem;
        // overflow: hidden;
        img{
            height: 100%;
        }
    }
    .textBox{
        width: 100%;
        height: .6rem;
        border-radius: .4rem .4rem 0 0;
        box-shadow:0px -1rem .35rem 0px rgba(50,50,50,0.22);
        // padding: .6rem 0 .5rem;
        // margin-top: -.2rem;
        background: #fff;
        position: absolute;
        left: 0;
        top: 4rem;
    }
    h2{
        color: #333;
        font-size: .46rem;
        font-weight: bold;
        text-align: center;
        margin-top: .4rem;
    }
    p{
        font-size: .3rem;
        color: #9A9A9A;
        margin-top: .17rem;
        text-align: center;
        margin-bottom: .55rem;
        padding: 0 .4rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span{
            color: #4FC0AC;
            background: rgba(108,214,196,.2);
            padding: .1rem .2rem;
            border-radius: .26rem;
        }
        &::before{
            content: "";
            width: .44rem;
            height: .02rem;
            background: #9A9A9A;
            display: block;
            margin: .24rem auto;
        }
    }
}
</style>